import React, { useState } from "react";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "What is GoWave?",
    a: "GoWave is a registered partnership firm that builds AI-powered enterprise software — including ClassScribe LMS, Hospital Management Systems, LiKAR distribution software, ERP solutions, and custom software for businesses of all sizes.",
  },
  {
    q: "What products does GoWave offer?",
    a: "Our product suite includes ClassScribe (AI-powered LMS for schools and enterprises), HMS (Hospital Management System), LiKAR (field-force and distribution management), ERP solutions, CRM systems, and fully custom software builds.",
  },
  {
    q: "Do you build software for other companies?",
    a: "Yes! Beyond our own products, GoWave provides custom software development services. We work with startups, SMEs, and enterprises to build tailored solutions — from web and mobile apps to complex enterprise platforms.",
  },
  {
    q: "How does the free trial work?",
    a: "You get full access to any of our products for 7 days, completely free. No credit card required. Use it with real data and your real team to see the impact before committing.",
  },
  {
    q: "What makes your software AI-powered?",
    a: "Our systems use machine learning for predictive analytics, natural language processing for smart search and automation, intelligent dashboards for real-time insights, and adaptive algorithms that learn from your data.",
  },
  {
    q: "Can the software be customized?",
    a: "Absolutely. Every product is tailored to your exact workflow. Share your requirements and we deliver a fully customized build. We also offer bespoke software development from scratch.",
  },
  {
    q: "What technologies do you use?",
    a: "We work with React, Next.js, Python, Node.js, Firebase, PostgreSQL, and modern AI/ML frameworks. Our stack is chosen to ensure performance, scalability, and maintainability.",
  },
  {
    q: "How can I get started?",
    a: "Simply reach out via our contact form, email us at contact@gowave.in, or click 'Hire Us' to start a conversation. We'll discuss your requirements and have you set up in no time.",
  },
];

function FAQComponent() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-section-new">
      <div className="container">
        <motion.div
          className="faq-header-new text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge faq-badge-new">FAQ</div>
          <h3>Frequently Asked Questions</h3>
          <p className="faq-subtitle-new">
            Everything you need to know about GoWave and our products.
          </p>
        </motion.div>

        <div className="faq-list-new">
          {faqs.map((item, i) => (
            <motion.div
              key={i}
              className={`faq-item-new ${activeIndex === i ? "faq-active" : ""}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              onClick={() => toggleFaq(i)}
            >
              <div className="faq-question-new">
                <span>{item.q}</span>
                <span className={`faq-toggle ${activeIndex === i ? "faq-toggle-open" : ""}`}>
                  {activeIndex === i ? "−" : "+"}
                </span>
              </div>
              {activeIndex === i && (
                <motion.div
                  className="faq-answer-new"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <p>{item.a}</p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQComponent;
